import SiteShell from "../components/SiteShell";

const perks = [
  "High ownership roles",
  "Fast decision culture",
  "Learning budget",
  "Hybrid collaboration",
];
const careerHighlights = [
  { label: "Processing Speed", value: "Real-time" },
  { label: "Target Audience", value: "Salaried" },
  { label: "Security Level", value: "Level 4" },
  { label: "Uptime Guaranteed", value: "99.99%" },
];

// const values = [
//   {
//     title: "Move Fast",
//     text: "We execute quickly, ship often, and learn continuously from users and partners.",
//   },
//   {
//     title: "Own Outcomes",
//     text: "Every team member owns results end-to-end, not just isolated tasks.",
//   },
//   {
//     title: "Build for Bharat",
//     text: "We design products for India's real-world scale and diversity.",
//   },
//   {
//     title: "Trust and Integrity",
//     text: "Security, compliance, and transparency are core to how we build.",
//   },
// ];

// const openings = [
//   {
//     role: "Frontend Engineer",
//     team: "Product Engineering",
//     location: "Gurgaon, India",
//     type: "Full-time",
//   },
//   {
//     role: "Backend Engineer",
//     team: "Platform",
//     location: "Gurgaon, India",
//     type: "Full-time",
//   },
//   {
//     role: "Risk Operations Manager",
//     team: "Risk and Compliance",
//     location: "Gurgaon, India",
//     type: "Full-time",
//   },
//   {
//     role: "Deployment Program Lead",
//     team: "Field Operations",
//     location: "Delhi NCR, India",
//     type: "Full-time",
//   },
// ];

function Career() {
  return (
    <SiteShell route="career" heroHidden={true} highlightsHidden={true}>
      <section className="relative overflow-hidden bg-[#061a2e] pb-14 pt-20 text-white sm:pb-16 sm:pt-24 lg:pb-20">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_10%,rgba(223,31,45,0.28),transparent_35%),radial-gradient(circle_at_90%_90%,rgba(18,169,191,0.2),transparent_35%)]" />
        <div className="relative z-10 mx-auto grid max-w-[1280px] items-center gap-8 px-4 sm:gap-10 sm:px-6 md:px-10 lg:gap-12 lg:grid-cols-[1.05fr_0.95fr]">
          <div>
            <p className="inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-1 text-[10px] font-black uppercase tracking-[0.3em] text-sky-200">
              Careers
            </p>
            <h1 className="mt-6 text-3xl font-extrabold leading-tight tracking-tight sm:mt-8 sm:text-5xl md:text-6xl lg:text-7xl">
              Build FinnCube
              <br />
              That Impacts
              <br />
              Millions
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-white/75 sm:mt-7 sm:text-base md:text-lg">
              Join finnCube and help shape India's next-generation
              assisted credit infrastructure. We are building fast, secure, and
              trusted experiences at national scale.
            </p>
            {/* <a
              href="#career-openings"
              className="mt-10 inline-flex rounded-full bg-[#e37921] px-8 py-3 text-xs font-black uppercase tracking-[0.15em] text-white transition hover:bg-[#e37921]"
            >
              View Open Roles
            </a> */}
          </div>
          <div className="relative">
            <div className="absolute -inset-4 rounded-[36px] bg-[#df1f2d]/15 blur-2xl" />
            <img
              src="/team_premium_office_1772861377531.png"
              alt="Career at Bharat Digital Finance"
              className="relative h-[300px] w-full rounded-[28px] border border-white/10 object-cover shadow-2xl sm:h-[380px] md:h-[440px] lg:h-[500px]"
            />
          </div>
        </div>
      </section>

      <section className="relative z-20 mx-auto -mt-8 max-w-[1280px] px-4 sm:-mt-10 sm:px-6 md:px-10">
        <div className="grid gap-4 rounded-3xl border border-slate-200 bg-white/80 p-4 shadow-[0_20px_50px_-12px_rgba(10,44,79,0.12)] backdrop-blur-2xl md:grid-cols-4 lg:p-6">
          {careerHighlights.map((item) => (
            <article
              key={item.label}
              className="group relative rounded-2xl bg-slate-50/50 p-6 transition-all hover:bg-white hover:shadow-xl"
            >
              <div className="absolute left-0 top-1/2 h-8 w-1 -translate-y-1/2 rounded-r-full bg-[#e37921] opacity-0 transition-opacity group-hover:opacity-100" />
              <p className="text-[15px] font-black uppercase tracking-[0.2em] text-[#e37921]/80">
                {item.label}
              </p>
              <h3 className="mt-2 text-xl font-extrabold tracking-tight text-[#0a2c4f]">
                {item.value}
              </h3>
            </article>
          ))}
        </div>
      </section>

      <section className="mx-auto mt-8 max-w-[1280px] px-4 sm:px-6 md:px-10">
        <div className="grid gap-3 rounded-3xl border border-slate-200 bg-white p-4 shadow-[0_25px_50px_-20px_rgba(0,0,0,0.18)] sm:gap-4 sm:p-5 md:grid-cols-2 lg:grid-cols-4">
          {perks.map((perk) => (
            <article
              key={perk}
              className="rounded-2xl border border-slate-100 bg-slate-50 p-4 text-center text-sm font-bold text-[#121212] sm:p-5"
            >
              {perk}
            </article>
          ))}
        </div>
      </section>

      <section
        id="career-openings"
        className="mx-auto max-w-[1280px] px-4 pb-14 pt-10 sm:px-6 sm:pb-20 sm:pt-12 md:px-10 md:pb-24"
      >
        <div className="rounded-[24px] bg-[#0a2c4f] p-4 text-white sm:rounded-[30px] sm:p-7 md:p-8 lg:p-10">
          <div className="flex flex-col gap-2 sm:gap-3 md:flex-row md:items-end md:justify-between">
            <h2 className="text-2xl font-extrabold tracking-tight sm:text-3xl md:text-4xl lg:text-5xl">
              Apply Now
            </h2>
            <p className="text-sm text-white/70 sm:text-base md:text-right">
              Send your profile: care@finncube.com
            </p>
          </div>

          <form
            action="mailto:care@finncube.com"
            method="POST"
            encType="multipart/form-data"
            className="mt-5 grid gap-4 rounded-2xl border border-white/15 bg-white/[0.04] p-3 sm:mt-7 sm:gap-5 sm:p-5 md:p-6 lg:mt-8 lg:gap-6 lg:p-8"
          >
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:gap-6">
        {/* Name Field */}
              <div className="flex w-full flex-col gap-1.5">
                <label htmlFor="name" className="text-xs font-semibold text-white/80 sm:text-sm md:text-base">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  placeholder="Your Name"
                  className="h-11 w-full rounded-xl border border-white/20 bg-white/5 px-3 text-sm text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-[#e37921] sm:h-12 sm:px-4 sm:text-base md:h-14 md:px-5 lg:h-16"
                />
              </div>

        {/* Email Field */}
              <div className="flex w-full flex-col gap-1.5">
                <label htmlFor="email" className="text-xs font-semibold text-white/80 sm:text-sm md:text-base">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  placeholder="you@example.com"
                  className="h-11 w-full rounded-xl border border-white/20 bg-white/5 px-3 text-sm text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-[#e37921] sm:h-12 sm:px-4 sm:text-base md:h-14 md:px-5 lg:h-16"
                />
              </div>
            </div>

      {/* Resume Upload */}
            <div className="flex w-full flex-col gap-1.5">
              <label htmlFor="resume" className="text-xs font-semibold text-white/80 sm:text-sm md:text-base">
                Upload Resume
              </label>
              <input
                type="file"
                name="resume"
                id="resume"
                accept=".pdf,.doc,.docx"
                required
                className="min-h-11 w-full rounded-xl border border-white/20 bg-white/5 px-2.5 py-2 text-xs text-white file:mr-2 file:rounded-md file:border-0 file:bg-white file:px-2.5 file:py-1.5 file:text-xs file:font-semibold file:text-[#0a2c4f] focus:outline-none focus:ring-2 focus:ring-[#e37921] sm:min-h-12 sm:px-3 sm:text-sm sm:file:mr-3 sm:file:px-3 sm:file:py-2 sm:file:text-sm md:min-h-14 md:px-4 md:text-base md:file:px-4 md:file:text-base"
              />
            </div>

      {/* Submit Button */}
            <button
              type="submit"
              className="mt-2 h-12 w-full rounded-full bg-[#e37921] px-6 text-sm font-black uppercase tracking-[0.12em] text-white transition hover:bg-[#cf691a] sm:mt-3 sm:h-14 sm:text-base"
            >
              Send
            </button>
          </form>
        </div>
      </section>
    </SiteShell>
  );
}

export default Career;
